import http from '@/utils/http'

export default {
  // 律师前三名展示数据请求接口
  getPositionLawyerList (params) {
    return http.get('/promotion/v1/api/lawyer/reviewLawyerList?pageIndex=' + params.pageIndex +
      '&pageSize=' + params.pageSize + '&lawyerName=' +
      params.lawyerName + '&city=' + params.city + '&expertField=' + params.expertField)
  },
  // 获取省份
  getProvinceList () {
    return http.get('/promotion/v1/api/region/regionList')
  }
}



// WEBPACK FOOTER //
// ./src/components/lawyer/api/index.js